import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Unidade {
  id: number;
  nome: string;
}

@Injectable({
  providedIn: 'root'
})
export class UnidadeService {
  //private apiUrl = 'https://localhost:7103/api/UnidadeLotacao'; // Altere para sua API correta

  //constructor(private http: HttpClient) { }

  //getUnidades(): Observable<Unidade[]> {
    //return this.http.get<Unidade[]>(this.apiUrl);
  //}

   private baseUrl = environment.apiUrlExbeOn;
    private endpoint = '/UnidadeLotacao';
    constructor(private http: HttpClient) { }
  
    getUnidades(): Observable<Unidade[]> {
      return this.http.get<Unidade[]>(`${this.baseUrl}${this.endpoint}`);
    }
}

